import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';

const MAXIMUM_THREAD_LEVEL = 1;

@Component({
  selector: 'lib-social-wall-reply',
  templateUrl: './social-wall-reply.component.html',
  styleUrl: './social-wall-reply.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SocialWallReplyComponent {

  public reply = input<any>({});
  public level = input(1);

  public like = output<any>();
  public replyTo = output<any>();
  public loadReplies = output<any>();

  public expanded = signal(false);

  public childReplies = computed<any[]>(() => this.reply()?.replies ?? []);
  public repliesLoaded = computed(() => this.reply()?.replies !== undefined);
  public repliesCount = computed(() => this.reply()?.replaysAmount ?? this.childReplies().length);
  public allowReply = computed(() => this.level() <= MAXIMUM_THREAD_LEVEL);
  public canExpand = computed(() => this.allowReply() && this.repliesCount() > 0);

  public toggleReplies(): void {
    const expanded = !this.expanded();
    this.expanded.set(expanded);

    if (expanded && !this.repliesLoaded()) {
      this.loadReplies.emit(this.reply());
    }
  }

}
